import { useQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';

export const StepKetosteril = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [ketosteril, setKetosteril] = useState(fullFormDataRI?.ketosteril1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    updateFormData('ketosteril1', ketosteril, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setKetosteril((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  const onDeleteImage = (name) => {
    handleChange(name, null);
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorERCestadio': combosRI?.idComboRIValorERCestadio
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        const input = {
          ...prevInput,
          options: prevInput.type == "select" || prevInput.type.includes("multiple") ? getOptionsByName(prevInput.name) : []
        };

        switch (input.name) {
          case 'laboratorioAdjunto':
            return {
              ...input,
              onDeleteImage: () => onDeleteImage(input.name)
            };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [selectedPrograms, combosRI]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [ketosteril, setDataSubmissionCallback, validatedinputsGroups]);

  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid
            container>
            {group.inputs.map((input) => {
              return (
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleChange={input.name === 'laboratorioAdjunto' ? handleChangeImage : handleChange}
                  input={input}
                  handleDelete={() => onDeleteImage(input.name)}
                  value={ketosteril[input.name]} />);


            })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepKetosteril;

const inputsGroups = [
  {
    groupName: 'Criterios de incrusición',
    inputs: [
      {
        displayName: 'ERC estadio',
        name: 'idComboRIValorERCestadio',
        comboName: 'ERC estadio',
        type: 'select',
        options: [],
        required: true
      },
      {
        displayName: 'Paciente en hemodialisis incremental',
        name: 'hemodialisisIncremental',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Paciente no quiere dializar',
        name: 'quiereDialisis',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Paciente post tx renal con deterioro',
        name: 'txrenalConDeterioro',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Paciente en recuperacion renal que sale de dialisis',
        name: 'recuperacionRenalDialisis',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'FG (MDRD/CKD-EPI)',
        name: 'fG',
        type: 'float',
        required: true
      },
      {
        displayName: 'Laboratorio',
        name: 'laboratorio',
        type: 'string',
        required: true
      },
      {
        displayName: 'Subir Laboratorio',
        name: 'laboratorioAdjunto',
        required: true,
        type: 'file',
        maxFileSize: 8
      }]

  }];